import { Box } from "@mui/system"
import { visuallyHidden } from "@mui/utils"
import { ISortOrder } from "app/model"
import React from "react"

interface IOrderByArrowProps {
  order: ISortOrder
  currentOrderBy: string
  columnOrderBy: string
}

export const OrderByArrow = React.memo(({ order, currentOrderBy, columnOrderBy }: IOrderByArrowProps) =>
  currentOrderBy === columnOrderBy ? (
    <Box component="span" sx={visuallyHidden}>
      {order === "desc" ? "sorted descending" : "sorted ascending"}
    </Box>
  ) : null
)
